<template>
   {{ params.date ? formatDate(params.date) : '-' }}
</template>

<script lang="ts" setup>
import type { DateCellParams, GridCellProps } from '~/composables/grid/cell-params'

const props = defineProps<GridCellProps<DateCellParams>>()

const { $dayjs } = useNuxtApp()
const formatDate = (date: string | Date) => {
   switch (props.params.type) {
      case 'relative':
         return $dayjs(date).isBefore($dayjs().add(-1, 'year'))
            ? $dayjs(date).format('DD MMM YYYY')
            : $dayjs(date).fromNow()
      case 'short':
         return $dayjs(date).format('DD MMM YYYY')
      default:
         return $dayjs(date).format('DD MMM YYYY HH:mm')
   }
}
</script>
